import { render, staticRenderFns } from "./RectangleDrawing.vue?vue&type=template&id=4d869bb8&"
import script from "./RectangleDrawing.vue?vue&type=script&lang=js&"
export * from "./RectangleDrawing.vue?vue&type=script&lang=js&"
import style0 from "./RectangleDrawing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports